import type { PostSubmissionRequest } from '@gdladder/shared/features';
import APIClient from '../APIClient';
import ms from 'ms';

export async function sendSubmission(submission: PostSubmissionRequest) {
    const res = await APIClient.post<{ wasAuto: boolean }>('/submissions', submission, {
        timeout: ms('20m'),
    });
    return res.data;
}
